/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Achievementgames1Inputs */

const id_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game dengan pencapaian`)
};

const ms_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan dengan pencapaian`)
};

const da_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement-spil`)
};

const de_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschafts-Spiele`)
};

const en_us2_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement games`)
};

const es_es2_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos con logros`)
};

const es_mx2_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos con logros`)
};

const fil_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga larong may achievement`)
};

const fr_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux avec succès`)
};

const it_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi con risultati`)
};

const hu_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítményekkel rendelkező játékok`)
};

const nl_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatiegames`)
};

const no_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill med prestasjoner`)
};

const pl_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gry z osiągnięciami`)
};

const pt_br2_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos de conquista`)
};

const pt_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos com conquistas`)
};

const ro_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri cu realizări`)
};

const fi_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutuspelit`)
};

const sv_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationsspel`)
};

const vi_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game có thành tích`)
};

const tr_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlı oyunlar`)
};

const cs_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry s úspěchy`)
};

const bg_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игри с постижения`)
};

const ru_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игры с достижениями`)
};

const uk_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігри з досягненнями`)
};

const ar_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ألعاب ذات إنجازات`)
};

const hi_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धि गेम`)
};

const th_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่มีความสำเร็จ`)
};

const ja_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績対応ゲーム`)
};

const zh_cn2_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有成就的游戏`)
};

const zh_hant1_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有成就的遊戲`)
};

const ko_profile_hero_achievementgames1 = /** @type {(inputs: Profile_Hero_Achievementgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 게임`)
};

/**
* | output |
* | --- |
* | "Achievement games" |
*
* @param {Profile_Hero_Achievementgames1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_achievementgames1 = /** @type {((inputs?: Profile_Hero_Achievementgames1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Achievementgames1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_achievementgames1(inputs)
	if (locale === "ms") return ms_profile_hero_achievementgames1(inputs)
	if (locale === "da") return da_profile_hero_achievementgames1(inputs)
	if (locale === "de") return de_profile_hero_achievementgames1(inputs)
	if (locale === "en-US") return en_us2_profile_hero_achievementgames1(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_achievementgames1(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_achievementgames1(inputs)
	if (locale === "fil") return fil_profile_hero_achievementgames1(inputs)
	if (locale === "fr") return fr_profile_hero_achievementgames1(inputs)
	if (locale === "it") return it_profile_hero_achievementgames1(inputs)
	if (locale === "hu") return hu_profile_hero_achievementgames1(inputs)
	if (locale === "nl") return nl_profile_hero_achievementgames1(inputs)
	if (locale === "no") return no_profile_hero_achievementgames1(inputs)
	if (locale === "pl") return pl_profile_hero_achievementgames1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_achievementgames1(inputs)
	if (locale === "pt") return pt_profile_hero_achievementgames1(inputs)
	if (locale === "ro") return ro_profile_hero_achievementgames1(inputs)
	if (locale === "fi") return fi_profile_hero_achievementgames1(inputs)
	if (locale === "sv") return sv_profile_hero_achievementgames1(inputs)
	if (locale === "vi") return vi_profile_hero_achievementgames1(inputs)
	if (locale === "tr") return tr_profile_hero_achievementgames1(inputs)
	if (locale === "cs") return cs_profile_hero_achievementgames1(inputs)
	if (locale === "bg") return bg_profile_hero_achievementgames1(inputs)
	if (locale === "ru") return ru_profile_hero_achievementgames1(inputs)
	if (locale === "uk") return uk_profile_hero_achievementgames1(inputs)
	if (locale === "ar") return ar_profile_hero_achievementgames1(inputs)
	if (locale === "hi") return hi_profile_hero_achievementgames1(inputs)
	if (locale === "th") return th_profile_hero_achievementgames1(inputs)
	if (locale === "ja") return ja_profile_hero_achievementgames1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_achievementgames1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_achievementgames1(inputs)
	return ko_profile_hero_achievementgames1(inputs)
});
export { profile_hero_achievementgames1 as "profile.hero.achievementGames" }